import { type Static, Type } from "@sinclair/typebox"

export const IdSchema = Type.String({
  minLength: 1,
})

export type Id = Static<typeof IdSchema>

export const NonEmptyStringSchema = Type.String({
  minLength: 1,
})

export type NonEmptyString = Static<typeof NonEmptyStringSchema>

export const IsoTimestampSchema = Type.String({
  pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d{3})?Z$",
})

export type IsoTimestamp = Static<typeof IsoTimestampSchema>

export const SeatIdSchema = Type.Union([
  Type.Literal("seat_a"),
  Type.Literal("seat_b"),
])

export type SeatId = Static<typeof SeatIdSchema>

export const ZoneIdSchema = Type.Union([
  Type.Literal("active"),
  Type.Literal("support"),
  Type.Literal("hand"),
  Type.Literal("deck"),
  Type.Literal("discard"),
  Type.Literal("scrap"),
  Type.Literal("supply"),
  Type.Literal("merc_row"),
])

export type ZoneId = Static<typeof ZoneIdSchema>
